module.exports = {"659008100":"榆树庄镇","659008101":"苇湖镇","659008102":"长丰镇","659008103":"金梁镇","659008104":"金屯镇","659008400":"可克达拉市核心区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659008.json
// module id = 3300
// module chunks = 0